module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-1-en.717471e4a89b978c1ff66b0a265a3842.png";